import React from 'react';
import "./search.css";

const Search = (
  {
    width,
    placeholder,
    onChange,
    searchValue
  }
) => {
  return (
    <div className="search_container" style={{width}}>
      <input
        type="text"
        placeholder={placeholder}
        onChange={e => onChange(e.target.value)}
        value={searchValue}
      />
    </div>
  )
};

export default Search;


// WEBPACK FOOTER //
// ./src/components/search/search-component.js